import { initializeApp, FirebaseApp } from 'firebase/app';
import { getDatabase, Database, ref, set, remove } from 'firebase/database';

// Firebase configuration
// TODO: Replace these values with your actual Firebase project credentials
// You can find these in your Firebase Console -> Project Settings -> General
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "YOUR_API_KEY",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "your-project.firebaseapp.com",
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL || "https://your-project.firebaseio.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "your-project-id",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "your-project.appspot.com",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "123456789",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "your-app-id"
};

// Initialize Firebase
let app: FirebaseApp | null = null;
let database: Database | null = null;

try {
  app = initializeApp(firebaseConfig);
  database = getDatabase(app);
} catch (error) {
  console.error('Error initializing Firebase — logout events will be skipped:', error);
  // Do NOT re-throw: a missing/invalid Firebase config must not break the app
}

/**
 * Write a logout event to Firebase Realtime Database
 * @param userEmail - The email of the user logging out
 * @returns Promise that resolves when the event is written
 */
export const writeLogoutEvent = async (userEmail: string): Promise<void> => {
  // NOTE: This is intentionally a REST write with `keepalive: true` rather than
  // the Firebase SDK's set(). Logout navigates the page (window.location.replace)
  // immediately after this call, which tears down the JS context before the SDK's
  // websocket write can flush — so the event was being silently dropped. A
  // keepalive fetch is guaranteed by the browser to complete even as the page
  // unloads, so the logout event reliably lands without blocking logout.
  const databaseURL = firebaseConfig.databaseURL;
  if (!userEmail || !databaseURL || databaseURL.includes('your-project')) {
    return;
  }

  try {
    const timestamp = Date.now();
    const sanitizedEmail = userEmail.replace(/[.#$[\]]/g, '_');
    const url = `${databaseURL.replace(/\/$/, '')}/logout_events/${sanitizedEmail}.json`;

    // PUT === set() at this path. keepalive lets it survive the logout navigation.
    await fetch(url, {
      method: 'PUT',
      keepalive: true,
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        loggedOut: true,
        timestamp: timestamp,
        triggeredFrom: 'convay.com',
        userEmail: userEmail,
        isoTimestamp: new Date(timestamp).toISOString()
      })
    });
  } catch (error) {
    console.error('Error writing logout event to Firebase:', error);
  }
};

export { database, ref, set, remove };
export default app!;
